// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cz2.cz2 .cz2__steps-options__actions--share{display:flex;gap:8px}@media(min-width:640px){#cz2.cz2 .cz2__steps-options__actions--share{gap:16px}}@media(min-width:768px){#cz2.cz2 .cz2__steps-options__actions--share{flex-direction:column}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
